export default "__VITE_ASSET__kqHMmVys__"